module.exports = __webpack_public_path__ + "static/img/indexTitle_hot.17b3ece.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/show/indexTitle/indexTitle_hot.png
// module id = JguD
// module chunks = 156